import React, { useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import GlobalProps from '../../globalProps';
import './Switcher.css';

interface Props extends GlobalProps {
  label?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  labels?: string[];
  disabled?: boolean;
  size?: 'small' | 'medium';
}

export function Switcher({ id, value, label, onChange, labels, disabled, size = 'medium' }: Props): JSX.Element {
  const [style, setStyle] = useState({
    transform: 'translateX(0)',
    width: 0,
  });
  const onRef = useRef<HTMLDivElement | null>(null);
  const offRef = useRef<HTMLDivElement | null>(null);

  function handleOnChange(v: boolean): void {
    if (onChange) {
      onChange(v);
    }
  }

  function calcStyle(): void {
    if (onRef && onRef.current && offRef && offRef.current) {
      if (value) {
        setStyle({
          transform: `translateX(${onRef.current.offsetLeft}px)`,
          width: onRef.current.clientWidth,
        });
      } else {
        setStyle({
          transform: `translateX(${offRef.current.offsetLeft}px)`,
          width: offRef.current.clientWidth,
        });
      }
    }
  }

  useEffect(() => {
    calcStyle();
  }, [value]);

  return (
    <div
      id={id}
      className={classnames('switcher', `switcher--${size}`, {
        'switcher--disabled': disabled,
      })}
    >
      {label && <label className="switcher__label">{label}</label>}
      <div className="switcher__wrapper">
        <div className="switcher__pill" style={style} />
        <div
          ref={onRef}
          className={classnames('switcher__option', {
            'switcher__option--active': value,
          })}
          onClick={() => {
            handleOnChange(true);
          }}
        >
          {(labels && labels[0]) || 'ON'}
        </div>
        <div
          ref={offRef}
          className={classnames('switcher__option', {
            'switcher__option--active': !value,
          })}
          onClick={() => {
            handleOnChange(false);
          }}
        >
          {(labels && labels[1]) || 'OFF'}
        </div>
      </div>
    </div>
  );
}
